import { Uploader } from "../../UI/Dropzone/Uploader";
import React, { useState } from "react";
import "./testiPhotos.css";
export const TestiPhotos = () => {
  const [instagramUser, setInstagramUser] = useState("");
  
  const handleChangeInstagramUser = ({target}) => {
    let instUser = target.value;
    let newUser = instUser.replace(/[^a-zA-Z0-9.@_]/g, "");
    setInstagramUser(newUser);
  };
  
  return (
    <div>
      <h1>Share Photos</h1>
      <p>
        You can upload any number of photos and up to 3 videos of your wedding
        and wedding flowers. We recommend at least 5 images showcasing your
        flowers. Think: The Happy Wedding Couple, The Wedding Party,
        Centerpieces and Arches. Bonus for the flower statement shot!
        <br />
        <br />* Videos must be limited in file size to under 120 MB or 1 minute
        in length.
      </p>
      <Uploader key={"dropUploader"} />
      <br />
      <div className="termsCheckDiv">
        <input
          type="checkbox"
          id="termsCheck"
          name="termsCheck"
          className="global-checkbox--input termsCheckInput"
        />
        <label htmlFor="termsCheck" className="global-checkbox--label form-label--checkbox termsCheckLabel">
          I agree to the{" "}
          <a
            href="/pages/win-your-wedding-flowers-rules"
            target="_blank"
            rel="noreferrer"
          >
            terms & conditions
          </a>{" "}
          and acknowledge that the Entry in the Contest constitutes Entrant’s
          and prize winner’s consent (without limitation including geographical
          limitation or compensation to Entrant) for Sponsor, and any third
          party in Sponsor’s sole discretion, to use Entrant’s Contest Entry,
          for any lawful purpose, including without limitation, the Entry and
          associated Instagram post, Entrant’s and nominee’s name, city and
          state of residence, likeness, photograph, video, and image for
          advertising, publicity and promotional purposes in any media, online
          or offline, without further permission, consent, payment or other
          consideration, except to the extent prohibited by law.
        </label>
      </div>
      <div className="pf-quantity-element">
        <label
          className="pf-quantity-label resizeLabels"
          htmlFor="instagramUser"
        >
          <span>
            <b>What's your instagram account? (e.g.:@FiftyFlowers) *:</b>
          </span>
        </label>
        <input
          type="text"
          id="instagramUser"
          name="instagramUser"
          className="form-input field__input  resizeInputs"
          value={instagramUser}
          onChange={handleChangeInstagramUser}
        />
      </div>
      <div className="pf-quantity-element">
        <label
          className="pf-quantity-label resizeLabels"
          htmlFor="photographer"
        >
          <span>
            <b>Who was your Photographer?:</b>
          </span>
        </label>
        <input
          type="text"
          id="photographer"
          name="photographer"
          className="form-input field__input  resizeInputs"
        />
      </div>
      <div className="pf-quantity-element">
        <label
          className="pf-quantity-label resizeLabels"
          htmlFor="photographer"
        >
          <span>
            <b>Who was your Videographer?:</b>
          </span>
        </label>
        <input
          type="text"
          id="videographer"
          name="videographer"
          className="form-input field__input  resizeInputs"
        />
      </div>
    </div>
  );
};
